<!--
  GlobalAlerts.vue - Contenedor de Alertas Globales

  Este componente se encarga de mostrar las notificaciones globales de la aplicación.
  - Se conecta al store de alertas de Pinia.
  - Muestra las alertas en una posición fija (ej: esquina superior derecha).
  - Utiliza transiciones de Vue para animar la entrada y salida de las alertas.
-->

<template>
  <div class="global-alerts-container">
    <TransitionGroup name="list" tag="div">
      <div
        v-for="alert in alertsStore.alerts"
        :key="alert.id"
        class="alert"
        :class="`alert-${alert.type}`"
      >
        <div class="alert-content">
          <span class="alert-icon">{{ getIcon(alert.type) }}</span>
          <p class="alert-message">{{ alert.message }}</p>
          <button @click="alertsStore.removeAlert(alert.id)" class="alert-close-btn">
            &times;
          </button>
        </div>
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup>
import { useAlertsStore } from '@/stores/alerts';

const alertsStore = useAlertsStore();

const getIcon = (type) => {
  switch (type) {
    case 'success':
      return '✅';
    case 'error':
      return '❌';
    case 'warning':
      return '⚠️';
    case 'info':
    default:
      return 'ℹ️';
  }
};
</script>

<style scoped>
.global-alerts-container {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
  max-width: 24rem;
}

.alert {
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  border-left-width: 4px;
  background-color: #fff;
  padding: 1rem;
  display: flex;
  align-items: center;
}

.alert-content {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
}

.alert-icon {
  font-size: 1.125rem;
  line-height: 1.75rem;
}

.alert-message {
  flex: 1;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #1f2937;
}

.alert-close-btn {
  font-size: 1.25rem;
  color: #9ca3af;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
}
.alert-close-btn:hover {
  color: #1f2937;
}

/* Tipos de Alerta */
.alert-success {
  border-color: #10b981;
}
.alert-error {
  border-color: #ef4444;
}
.alert-warning {
  border-color: #f59e0b;
}
.alert-info {
  border-color: #3b82f6;
}

/* Transiciones */
.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}
.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
